import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import truncate from 'lodash/truncate';
import classnames from 'classnames';
import idx from 'idx';

const BlogGallery = ({ background, items, cta, title }) => {
  return (
    <div className={classnames("block block-blog-gallery", background)}>
      <div className="block-header">
        <h2 className="text-center">{ title }</h2>
      </div>
      <div className="row small-up-1 medium-up-2 large-up-3">
        { items.map((item, i) => (
        <div className="columns" key={i}>
          <div className="tile">
            <Link to={item.url} target="_blank">
              <div className="image" style={{ backgroundImage: `url("${item.image.src}")` }} />
            </Link>
            <div className="text-content">
              <Link className="category" to={item.category.url} target="_blank">
                { item.category.name }
              </Link>
              <h3>
                <Link to={item.url} target="_blank"> { truncate(item.title, { length: 50 }) }</Link>
              </h3>
              <p>{ item.description }</p>
            </div>
          </div>
        </div>
        )) }
      </div>
      <div className="text-center blog-gallery-cta">
        <Link target="_blank" to={idx(cta, _ => _.link) || "https://crowdspring.com/blog/"}>
          { idx(cta, _ => _.label) || "See more from our award-winning Blog" }
        </Link>
      </div>
    </div>
  );
}

BlogGallery.propTypes = {
  background: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  cta: PropTypes.object
}

export default BlogGallery;



// WEBPACK FOOTER //
// ./landing_pages/components/blog_gallery.jsx